import "./PhieuXuatKho.css";

import {
    useEffect,
    useState,
    useRef,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { NewdanhmucphieuxuatAction } from 'src/actions/newdanhmucphieuxuat.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    MenuItem,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    InputLabel,
    TableCell,
} from '@material-ui/core';

import Select from 'react-select';

import numeral from 'numeral';

import { Search as SearchIcon } from 'react-feather';

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
    SIM_TYPE_LIST_OBJ_WITHOUT_OPERATOR,
} from 'src/utils/constants';

import moment from 'moment';
import { isGrantPermission, numberToVietnameseWords } from 'src/utils/utils';
import { NewdanhmucsanphamAction } from 'src/actions/newdanhmucsanpham.action';
import { NewdanhmuckhohangAction } from 'src/actions/newdanhmuckhohang.action';
import { NewdanhmucchiphiphatsinhAction } from "src/actions/newdanhmucchiphiphatsinh.action";

import CreateEditDialogNewdanhmuckhachhang from '../newdanhmuckhachhang-detail/CreateEditDialog';
import CreateEditDialogNewdanhmuckhohang from '../newdanhmuckhohang-detail/CreateEditDialog';
import CreateEditDialogNewdanhmucsanpham from '../newdanhmucsanpham-detail/CreateEditDialog';
import CreateEditDialogNewdanhmucchiphiphatsinh from '../newdanhmucchiphiphatsinh-detail/CreateEditDialog';
import { NewdanhmuckhachhangAction } from "src/actions/newdanhmuckhachhang.action";

import { toIntDate } from 'src/utils/common.js';

const CreateEditDialog = (props) => {
    const dispatch = useDispatch();
    const today = new Date();
    const padZero = (num) => String(num).padStart(2, "0");
    
    const { items } = useSelector(state => state.permission);
    const { selected } = useSelector(state => state.newdanhmucphieuxuat);
    const { info, permissions, role } = useSelector(state => state.profile);
    const [tabSelect, setTabSelect] = useState("phieu_xuat");
    const [ngay, setNgay] = useState(padZero(String(today.getDate())));
    const [thang, setThang] = useState(padZero(String(today.getMonth() + 1)));
    const [nam, setNam] = useState(padZero(String(today.getFullYear())));
    const [no, setNo] = useState("");
    const [co, setCo] = useState("");
    // const [so, setSo] = useState("{Hiển thị sau khi tạo phiếu}");
    const [so, setSo] = useState("");
    const [dia_chi, setDiaChi] = useState("");

    const [ho_va_ten_nguoi_nhan, setHoVaTenNguoiNhan] = useState("");
    const [so_dien_thoai_nguoi_nhan, setSoDienThoaiNguoiNhan] = useState("");
    const [dia_chi_nguoi_nhan, setDiaChiNguoiNhan] = useState("");
    const [ly_do_xuat_kho, setLyDoXuatKho] = useState("");
    const [tong_so_tien_viet_bang_chu, setTongSoTienVietBangChu] = useState("");
    const [so_chung_tu_goc_kem_theo, setSoChungTuGocKemTheo] = useState("");

    const [phieu_thu_quyen_so, setPhieuThuQuyenSo] = useState("");
    const [phieu_thu_so, setPhieuThuSo] = useState("");
    const [phieu_thu_no, setPhieuThuNo] = useState("");
    const [phieu_thu_co, setPhieuThuCo] = useState("");
    const [phieu_thu_noi_dung_thu, setPhieuThuNoiDungThu] = useState("");
    const [phieu_thu_so_tien, setPhieuThuSoTien] = useState("");
    const [phieu_thu_so_tien_viet_bang_chu, setPhieuThuSoTienVietBangChu] = useState("");
    const [phieu_thu_kem_theo, setPhieuThuKemTheo] = useState("");
    const [phieu_thu_chung_tu_goc, setPhieuThuChungTuGoc] = useState("");
    const [phieu_thu_da_nhan_du_so_tien_viet_bang_chu, setPhieuThuDaNhanDuSoTienVietBangChu] = useState("");
    const [phieu_thu_ty_gia_ngoai_te, setPhieuThuTyGiaNgoaiTe] = useState("");
    const [phieu_thu_so_tien_quy_doi, setPhieuThuSoTienQuyDoi] = useState("");

    const [rows, setRows] = useState([
        { id: 1, name: "", code: "", unit: "", qtyDoc: "", qtyReal: "", price: "", total: "", mode: "sanpham", ghi_chu: "" },
    ]);

    const [chiphiphatsinhList, setChiphiphatsinhList] = useState([]);
    const [sanphamList, setSanphamList] = useState([]);

    const [khohang_id, setKhohangId] = useState("-99");
    const [khohang_name, setKhohangName] = useState("");
    const [khohang_select, setKhohangSelect] = useState(undefined);
    const [khohangList, setKhohangList] = useState([]);

    const [khachhang_id, setKhachhangId] = useState("-99");
    const [khachhang_name, setKhachhangName] = useState("");
    const [khachhang_select, setKhachhangSelect] = useState(undefined);
    const [khachhangList, setKhachhangList] = useState([]);

    const [tongSoLuongChungTu, setTongSoLuongChungTu] = useState("x");
    const [tongSoLuongThucNhap, setTongSoLuongThucNhap] = useState("x");
    const [tongDonGia, setTongDonGia] = useState("x");
    const [tongThanhTien, setTongThanhTien] = useState("x");

    const [mode, setMode] = useState("sanpham");

    const defaultSelectChiphiphatsinh = 'Chi phí...';
    const defaultSelectSanPham = 'Sản phẩm...';
    const defaultSelectKhoHang = 'Kho hàng...';
    const defaultSelectKhachHang = 'Khách hàng...';
    const defaultSelectDangkiem = 'Đăng kiểm...';

    const additionalOptionChiphiphatsinh = { 'id': '-99', 'ma': defaultSelectChiphiphatsinh, 'ten': '' };
    const additionalOptionSanpham = { 'id': '-99', 'ma': defaultSelectSanPham, 'ten': '' };
    const additionalOptionKhohang = { 'id': '-99', 'ma': defaultSelectKhoHang, 'ten': '' };
    const additionalOptionKhachhang = { 'id': '-99', 'ma': defaultSelectKhachHang, 'ten': '' };
    const additionalOptionDangkiem = { 'id': '-99', 'ma': defaultSelectDangkiem, 'so_khung': '', 'so_may': '' };

    const [openNewdanhmuckhachhang, setOpenNewdanhmuckhachhang] = useState(false);
    const [openNewdanhmuckhohang, setOpenNewdanhmuckhohang] = useState(false);
    const [openNewdanhmucsanpham, setOpenNewdanhmucsanpham] = useState(false);
    const [openNewdanhmucchiphiphatsinh, setOpenNewdanhmucchiphiphatsinh] = useState(false);

    //==========

    const handleClickOpenNewdanhmuckhachhang = () => {
        setOpenNewdanhmuckhachhang(true);
    };

    const handleCloseNewdanhmuckhachhang = () => {
        setOpenNewdanhmuckhachhang(false);
        fetchData();
    };

    //==========

    const handleClickOpenNewdanhmuckhohang = () => {
        setOpenNewdanhmuckhohang(true);
    };

    const handleCloseNewdanhmuckhohang = () => {
        setOpenNewdanhmuckhohang(false);
        fetchData();
    };

    //==========

    const handleClickOpenNewdanhmucsanpham = () => {
        setOpenNewdanhmucsanpham(true);
    };

    const handleCloseNewdanhmucsanpham = () => {
        setOpenNewdanhmucsanpham(false);
        fetchData();
    };

    //==========

    const handleClickOpenNewdanhmucchiphiphatsinh = () => {
        setOpenNewdanhmucchiphiphatsinh(true);
    };

    const handleCloseNewdanhmucchiphiphatsinh = () => {
        setOpenNewdanhmucchiphiphatsinh(false);
        fetchData();
    };

    //==========

    const fetchData = async() => {
        const _chiphiphatsinhList = await dispatch(NewdanhmucchiphiphatsinhAction.chiphiphatsinhList());
        if (_chiphiphatsinhList && typeof _chiphiphatsinhList.data !== 'undefined' && typeof _chiphiphatsinhList.data.values !== 'undefined') setChiphiphatsinhList(_chiphiphatsinhList.data.values);

        const _sanphamList = await dispatch(NewdanhmucsanphamAction.sanphamList());
        if (_sanphamList && typeof _sanphamList.data !== 'undefined' && typeof _sanphamList.data.values !== 'undefined') setSanphamList(_sanphamList.data.values);

        const _khohangList = await dispatch(NewdanhmuckhohangAction.khohangList());
        if (_khohangList && typeof _khohangList.data !== 'undefined' && typeof _khohangList.data.values !== 'undefined') setKhohangList(_khohangList.data.values);

        const _khachhangList = await dispatch(NewdanhmuckhachhangAction.khachhangList());
        if (_khachhangList && typeof _khachhangList.data !== 'undefined' && typeof _khachhangList.data.values !== 'undefined') setKhachhangList(_khachhangList.data.values);
    }

    useEffect(() => {
        if (props.open == true && !props.no_fetching) {
            fetchData();

            // resetState();

            setTabSelect('phieu_xuat');

            if (props.type == 'CREATE') {
                // recalculate([], false);
            }

            if (props.type == 'EDIT' && selected) {
                resetState();

                setHoVaTenNguoiNhan(selected.ho_va_ten_nguoi_nhan ?? '');
                setSoDienThoaiNguoiNhan(selected.so_dien_thoai_nguoi_nhan ?? '');
                setDiaChiNguoiNhan(selected.dia_chi_nguoi_nhan ?? '');
                setLyDoXuatKho(selected.ly_do_xuat_kho ?? '');
                setTongSoTienVietBangChu(selected.tong_so_tien_viet_bang_chu ?? '');
                setSoChungTuGocKemTheo(selected.so_chung_tu_goc_kem_theo ?? '');

                setPhieuThuQuyenSo(selected.phieu_thu_quyen_so ?? '');
                setPhieuThuSo(selected.phieu_thu_so ?? '');
                setPhieuThuNo(selected.phieu_thu_no ?? '');
                setPhieuThuCo(selected.phieu_thu_co ?? '');
                setPhieuThuNoiDungThu(selected.phieu_thu_noi_dung_thu ?? '');
                setPhieuThuSoTien(selected.phieu_thu_so_tien ?? '');
                setPhieuThuSoTienVietBangChu(selected.phieu_thu_so_tien_viet_bang_chu ?? '');
                setPhieuThuKemTheo(selected.phieu_thu_kem_theo ?? '');
                setPhieuThuChungTuGoc(selected.phieu_thu_chung_tu_goc ?? '');
                setPhieuThuDaNhanDuSoTienVietBangChu(selected.phieu_thu_da_nhan_du_so_tien_viet_bang_chu ?? '');
                setPhieuThuTyGiaNgoaiTe(selected.phieu_thu_ty_gia_ngoai_te ?? '');
                setPhieuThuSoTienQuyDoi(selected.phieu_thu_so_tien_quy_doi ?? '');

                setNgay(padZero(selected.ngay));
                setThang(padZero(selected.thang));
                setNam(padZero(selected.nam));
                setNo(selected.no ?? '');
                setCo(selected.co ?? '');
                setSo(selected.so ?? '');

                //==========

                if (selected.khohang_ma && selected.khohang_ma.trim() != '') {
                    const khohangLineDefault = `<div style="font-weight: bold">${selected.khohang_ma} ${selected.khohang_ten ? ` - ${selected.khohang_ten}` : ''}</div>`;
                    
                    const htmlDefault = `
                        <div>
                            ${khohangLineDefault}
                        </div>
                    `;
                    
                    setKhohangId("__OLD_ID__");
                    setKhohangName(htmlDefault);
                    setDiaChi(selected.khohang_dia_chi);
                }

                //==========

                if (selected.khachhang_ma && selected.khachhang_ma.trim() != '') {
                    const khachhangLineDefault = `<div style="font-weight: bold">${selected.khachhang_ma} ${selected.khachhang_ten ? ` - ${selected.khachhang_ten}` : ''}</div>`;
                    
                    const htmlDefault = `
                        <div>
                            ${khachhangLineDefault}
                        </div>
                    `;
                    
                    setKhachhangId("__OLD_ID__");
                    setKhachhangName(htmlDefault);
                    setHoVaTenNguoiNhan(selected.khachhang_ten);
                    setDiaChiNguoiNhan(selected.khachhang_dia_chi);
                    setSoDienThoaiNguoiNhan(selected.khachhang_sdt);
                }

                //==========

                if (selected.newdanhmucphieuxuatchitiets && selected.newdanhmucphieuxuatchitiets.length > 0) {
                    let newRows = [];
                    let newdanhmucphieuxuatchitiets = [...selected.newdanhmucphieuxuatchitiets].sort((a, b) => a.index - b.index);
                    for (let i = 0; i < newdanhmucphieuxuatchitiets.length; i++) {
                        if (newdanhmucphieuxuatchitiets[i]?.item_type == 'chiphiphatsinh') {
                            let chiphiphatsinh = newdanhmucphieuxuatchitiets[i];
                            
                            const chiphiphatsinhLine = `<div style="font-weight: bold">${chiphiphatsinh.chiphiphatsinh_ten ? `${chiphiphatsinh.chiphiphatsinh_ten}` : ''}</div>`;
                        
                            const html = `
                                <div>
                                    ${chiphiphatsinhLine}
                                </div>
                            `;

                            newRows[i] = {};
                            newRows[i]['id'] = i + 1;
                            newRows[i]['code'] = chiphiphatsinh.chiphiphatsinh_ma;
                            newRows[i]['unit'] = chiphiphatsinh.don_vi_tinh;
                            newRows[i]['qtyDoc'] = '0';
                            newRows[i]['qtyReal'] = chiphiphatsinh.so_luong_thuc_nhap;
                            newRows[i]['mode'] = 'chiphiphatsinh';
                            newRows[i]['ghi_chu'] = chiphiphatsinh.ghi_chu;
                            newRows[i]['name'] = {
                                item_type: 'chiphiphatsinh',
                                chiphiphatsinh_id: "__OLD_ID__",
                                chiphiphatsinh_ma: chiphiphatsinh.chiphiphatsinh_ma,
                                chiphiphatsinh_name: html,
                                chiphiphatsinh_select: {
                                    id: chiphiphatsinh.chiphiphatsinh_id,
                                    ma: chiphiphatsinh.chiphiphatsinh_ma,
                                    ten: chiphiphatsinh.chiphiphatsinh_ten,
                                    gia: typeof chiphiphatsinh.chiphiphatsinh_gia !== 'undefined' ? chiphiphatsinh.chiphiphatsinh_gia : null,
                                }
                            };
                        } else if (newdanhmucphieuxuatchitiets[i]?.item_type == 'sanpham') {
                            let sanpham = newdanhmucphieuxuatchitiets[i];
                            
                            const productLine = `<div style="font-weight: bold">${sanpham.sanpham_ten ? `${sanpham.sanpham_ten}` : ''}</div>`;
                            
                            const ncc = sanpham.nhacungcap_ma
                                ? `<div>(${sanpham.nhacungcap_ma} - ${sanpham.nhacungcap_ten})<div>`
                                : null;
                        
                            const html = `
                                <div>
                                    ${productLine}
                                    ${ncc}
                                </div>
                            `;

                            newRows[i] = {};
                            newRows[i]['id'] = i + 1;
                            newRows[i]['code'] = sanpham.sanpham_ma;
                            newRows[i]['unit'] = sanpham.don_vi_tinh;
                            newRows[i]['qtyDoc'] = sanpham.so_luong_chung_tu;
                            newRows[i]['qtyReal'] = sanpham.so_luong_thuc_nhap;
                            newRows[i]['gia_custom'] = sanpham.gia_custom;
                            newRows[i]['price'] = sanpham.price_key;
                            newRows[i]['mode'] = 'sanpham';
                            newRows[i]['ghi_chu'] = sanpham.ghi_chu;
                            newRows[i]['name'] = {
                                item_type: 'sanpham',
                                sanpham_id: "__OLD_ID__",
                                sanpham_ma: sanpham.sanpham_ma,
                                sanpham_name: html,
                                sanpham_select: {
                                    id: sanpham.sanpham_id,
                                    ma: sanpham.sanpham_ma,
                                    ten: sanpham.sanpham_ten,
                                    gia_nhap: typeof sanpham.sanpham_gia_nhap !== 'undefined' ? sanpham.sanpham_gia_nhap : null,
                                    chiet_khau_1: typeof sanpham.sanpham_chiet_khau_1 !== 'undefined' ? sanpham.sanpham_chiet_khau_1 : null,
                                    chiet_khau_2: typeof sanpham.sanpham_chiet_khau_2 !== 'undefined' ? sanpham.sanpham_chiet_khau_2 : null,
                                    chiet_khau_3: typeof sanpham.sanpham_chiet_khau_3 !== 'undefined' ? sanpham.sanpham_chiet_khau_3 : null,
                                    gia_thuc_nhap_si_1: typeof sanpham.sanpham_gia_thuc_nhap_si_1 !== 'undefined' ? sanpham.sanpham_gia_thuc_nhap_si_1 : null,
                                    gia_thuc_nhap_si_2: typeof sanpham.sanpham_gia_thuc_nhap_si_2 !== 'undefined' ? sanpham.sanpham_gia_thuc_nhap_si_2 : null,
                                    gia_thuc_nhap_si_3: typeof sanpham.sanpham_gia_thuc_nhap_si_3 !== 'undefined' ? sanpham.sanpham_gia_thuc_nhap_si_3 : null,
                                    giaxuat1: typeof sanpham.giaxuat1 !== 'undefined' ? sanpham.giaxuat1 : null,
                                    giaxuat2: typeof sanpham.giaxuat2 !== 'undefined' ? sanpham.giaxuat2 : null,
                                    giaxuat3: typeof sanpham.giaxuat3 !== 'undefined' ? sanpham.giaxuat3 : null,
                                    newdanhmucnhacungcap_ref: {
                                        id: "__OLD_ID__",
                                        ma: sanpham.nhacungcap_ma,
                                        ten: sanpham.nhacungcap_ten,
                                        mst: sanpham.nhacungcap_mst,
                                        dia_chi: sanpham.nhacungcap_dia_chi,
                                        sdt: sanpham.nhacungcap_sdt,
                                        email: sanpham.nhacungcap_email,
                                    },
                                    newdanhmucdangkiems: sanpham?.newdanhmucsanpham_ref?.newdanhmucdangkiems || [],
                                }
                            };

                            if (sanpham.dangkiem_id) {
                                const soKhungLine = `<div style="font-style: italic">${sanpham.dangkiem_so_khung ? `SK: ${sanpham.dangkiem_so_khung}` : ''}</div>`;
                                const soMayLine = `<div style="font-style: italic">${sanpham.dangkiem_so_may ? `SM: ${sanpham.dangkiem_so_may}` : ''}</div>`;
                            
                                const htmldangkiem = `
                                    <div>
                                        ${soKhungLine}
                                        ${soMayLine}
                                    </div>
                                `;

                                newRows[i]['dangkiem'] = {
                                    dangkiem_id: "__OLD_ID__",
                                    dangkiem_so_khung: sanpham.dangkiem_so_khung,
                                    dangkiem_so_may: sanpham.dangkiem_so_may,
                                    dangkiem_name: htmldangkiem,
                                    dangkiem_select: {
                                        id: sanpham.dangkiem_id,
                                        so_khung: sanpham.dangkiem_so_khung,
                                        so_may: sanpham.dangkiem_so_may,
                                        mau_sac: sanpham.dangkiem_mau_sac,
                                        an_chi: sanpham.dangkiem_an_chi,
                                        ghi_chu: sanpham.dangkiem_ghi_chu,
                                        ngay_xuat_xuong: sanpham.dangkiem_ngay_xuat_xuong,
                                        ngay_tra_dang_kiem: sanpham.dangkiem_ngay_tra_dang_kiem,
                                    },
                                }
                            }
                        }
                    }

                    setRows(newRows);
                    recalculate(newRows, false);
                } else {
                    recalculate([], false);
                }
            }
        }
    }, [props])

    function getDuplicateKhungMay(product_rows) {
        const map = {};
        const duplicates = [];
    
        product_rows.forEach(row => {
            const sk = row?.dangkiem?.dangkiem_so_khung?.trim();
            const sm = row?.dangkiem?.dangkiem_so_may?.trim();
            if (!sk || !sm) return;
    
            const key = `${sk}__${sm}`;
    
            if (!map[key]) {
                map[key] = 1;
            } else {
                map[key]++;
            }
        });
    
        // Chỉ lấy các key có >1 lần xuất hiện
        Object.keys(map).forEach(key => {
            if (map[key] > 1) {
                const [sk, sm] = key.split("__");
                duplicates.push({
                    so_khung: sk,
                    so_may: sm
                });
            }
        });
    
        return duplicates;
    }    

    const onPressPositive = async() => {
        if (khachhang_id === "-99") {
            alert('Vui lòng chọn khách hàng!');
            return;
        }

        if (khohang_id === "-99") {
            alert('Vui lòng chọn kho hàng!');
            return;
        }

        if (!toIntDate(padZero(ngay), padZero(thang), padZero(nam))) {
            alert('Ngày nhập phiếu không hợp lệ!');
            return;
        }

        if (props.type === 'EDIT') {
            const checkSoKhungSoMay = await dispatch(NewdanhmucphieuxuatAction.checkSoKhungSoMay({
                phieu_id: selected.id,
                product_rows: rows
            }));
            if (checkSoKhungSoMay) {
                if (checkSoKhungSoMay.result == 'failed') {
                    alert("Lỗi kiểm tra số khung - số máy");
                    return;
                }

                alert(`Bộ số khung - số máy này đã tồn tại ở phiếu khác:\n\nSK: ${checkSoKhungSoMay.so_khung} - SM: ${checkSoKhungSoMay.so_may}\n\nVui lòng kiểm tra lại!`);
                return;
            }

            const checkTrungBoMaTrongPhieuHienTai = getDuplicateKhungMay(rows);
            if (checkTrungBoMaTrongPhieuHienTai && checkTrungBoMaTrongPhieuHienTai.length > 0) {
                const message = checkTrungBoMaTrongPhieuHienTai
                    .map((item, index) => `${index + 1}. SK: ${item.so_khung} - SM: ${item.so_may}`)
                    .join("\n");

                alert(
                    "Các bộ số khung – số máy sau bị trùng trong phiếu:\n\n" +
                    message +
                    "\n\nVui lòng kiểm tra lại!"
                );

                return;
            }

            console.log(selected);
            dispatch(NewdanhmucphieuxuatAction.update(selected.id, { 
                kho_hang: khohang_id,
                khach_hang: khachhang_id,
                product_rows: rows,

                ngay: padZero(ngay),
                thang: padZero(thang),
                nam: padZero(nam),
                no,
                co,
                so,

                ho_va_ten_nguoi_nhan,
                so_dien_thoai_nguoi_nhan,
                dia_chi_nguoi_nhan,
                ly_do_xuat_kho,
                tong_so_tien_viet_bang_chu,
                so_chung_tu_goc_kem_theo,

                phieu_thu_quyen_so,
                phieu_thu_so,
                phieu_thu_no,
                phieu_thu_co,
                phieu_thu_noi_dung_thu,
                phieu_thu_so_tien,
                phieu_thu_so_tien_viet_bang_chu,
                phieu_thu_kem_theo,
                phieu_thu_chung_tu_goc,
                phieu_thu_da_nhan_du_so_tien_viet_bang_chu,
                phieu_thu_ty_gia_ngoai_te,
                phieu_thu_so_tien_quy_doi,
            }))
            resetState();
        } else {
            const checkSoKhungSoMay = await dispatch(NewdanhmucphieuxuatAction.checkSoKhungSoMay({
                phieu_id: null,
                product_rows: rows
            }));
            if (checkSoKhungSoMay) {
                if (checkSoKhungSoMay.result == 'failed') {
                    alert("Lỗi kiểm tra số khung - số máy");
                    return;
                }

                alert(`Bộ số khung - số máy này đã tồn tại ở phiếu khác:\n\n${checkSoKhungSoMay.so_khung} - ${checkSoKhungSoMay.so_may}\n\nVui lòng kiểm tra lại!`);
                return;
            }

            const checkTrungBoMaTrongPhieuHienTai = getDuplicateKhungMay(rows);
            if (checkTrungBoMaTrongPhieuHienTai && checkTrungBoMaTrongPhieuHienTai.length > 0) {
                const message = checkTrungBoMaTrongPhieuHienTai
                    .map((item, index) => `${index + 1}. SK: ${item.so_khung} - SM: ${item.so_may}`)
                    .join("\n");

                alert(
                    "Các bộ số khung – số máy sau bị trùng trong phiếu:\n\n" +
                    message +
                    "\n\nVui lòng kiểm tra lại!"
                );

                return;
            }

            dispatch(NewdanhmucphieuxuatAction.create({ 
                kho_hang: khohang_id,
                khach_hang: khachhang_id,
                product_rows: rows,
                
                ngay: padZero(ngay),
                thang: padZero(thang),
                nam: padZero(nam),
                no,
                co,
                so,

                ho_va_ten_nguoi_nhan,
                so_dien_thoai_nguoi_nhan,
                dia_chi_nguoi_nhan,
                ly_do_xuat_kho,
                tong_so_tien_viet_bang_chu,
                so_chung_tu_goc_kem_theo,

                phieu_thu_quyen_so,
                phieu_thu_so,
                phieu_thu_no,
                phieu_thu_co,
                phieu_thu_noi_dung_thu,
                phieu_thu_so_tien,
                phieu_thu_so_tien_viet_bang_chu,
                phieu_thu_kem_theo,
                phieu_thu_chung_tu_goc,
                phieu_thu_da_nhan_du_so_tien_viet_bang_chu,
                phieu_thu_ty_gia_ngoai_te,
                phieu_thu_so_tien_quy_doi,
            }, props.creatingFromAway))
        }
        // resetState();
        props.handleClose();
    }

    const resetState = () => {
        setHoVaTenNguoiNhan("");
        setSoDienThoaiNguoiNhan("");
        setDiaChiNguoiNhan("");
        setLyDoXuatKho("");
        setTongSoTienVietBangChu("");
        setSoChungTuGocKemTheo("");

        setPhieuThuQuyenSo("");
        setPhieuThuSo("");
        setPhieuThuNo("");
        setPhieuThuCo("");
        setPhieuThuNoiDungThu("");
        setPhieuThuSoTien("");
        setPhieuThuSoTienVietBangChu("");
        setPhieuThuKemTheo("");
        setPhieuThuChungTuGoc("");
        setPhieuThuDaNhanDuSoTienVietBangChu("");
        setPhieuThuTyGiaNgoaiTe("");
        setPhieuThuSoTienQuyDoi("");

        setNgay(padZero(String(today.getDate())));
        setThang(padZero(String(today.getMonth() + 1)));
        setNam(padZero(String(today.getFullYear())));
        setNo("");
        setCo("");
        // setSo("{Hiển thị sau khi tạo phiếu}");
        setSo("");

        // setRows([
        //     { id: 1, name: "", code: "", unit: "", qtyDoc: "", qtyReal: "",  price: "", total: "", mode: "sanpham", ghi_chu: "" },
        // ])

        setRows([]);

        setSanphamList([]);

        setKhohangId("-99");
        setKhohangName("");
        setKhohangSelect(undefined);
        setKhohangList([]);

        setKhachhangId("-99");
        setKhachhangName("");
        setKhachhangSelect(undefined);
        setKhachhangList([]);

        fetchData();
    }

    const inputsRef = useRef({});

    const addRow = () => {
        setRows((prev) => {
            const updatedRows = [
                ...prev,
                {
                    id: prev.length + 1,
                    name: "",
                    code: "",
                    unit: "",
                    qtyDoc: "",
                    qtyReal: "",
                    price: "",
                    total: "",
                    mode: "sanpham",
                    ghi_chu: "",
                },
            ];
            recalculate(updatedRows, false);
            return updatedRows;
        });
    };    

    const removeRow = (id) => {
        setRows((prev) => {
            const updatedRows = prev.filter((r) => r.id !== id);
            recalculate(updatedRows, false);
            return updatedRows;
        });
    };

    const handleKeyDown = (e, rowIndex, fieldIndex) => {
        if (e.key === "Tab") {
            const fields = ["name", "code", "unit", "qtyDoc", "qtyReal", "price", "total"];
            const isLastRow = rowIndex === rows.length - 1;
            const isLastField = fieldIndex === fields.length - 1;

            if (isLastRow && isLastField) {
                e.preventDefault();
                addRow();
                setTimeout(() => {
                    const newRowIndex = rowIndex + 1;
                    const field = fields[0];
                    const input = inputsRef.current[`${newRowIndex}-${field}`];
                    if (input) input.focus();
                }, 50);
            }
        }
    };

    const recalculate = (_rows = [], useDefault = true, loaiPhieu = 'phieu_xuat', useDefaultLoaiPhieu = true) => {
        let _tongSoLuongChungTu = 0;
        let _tongSoLuongThucNhap = 0;
        let _tongDonGia = 0;
        let _tongThanhTien = 0;

        let _tongSoLuongChungTuSanPham = 0;
        let _tongSoLuongThucNhapSanPham = 0;
        let _tongDonGiaSanPham = 0;
        let _tongThanhTienSanPham = 0;

        if (useDefault && _rows.length <= 0) _rows = rows;
        if (useDefaultLoaiPhieu && tabSelect) loaiPhieu = tabSelect;
        if (_rows && _rows.length > 0) {
            for (let rowIndex = 0; rowIndex < _rows.length; rowIndex++) {
                let soLuongChungTu = 0;
                let soLuongThucNhap = 0;
                let priceKey = null;
                let donGia = 0;
                let thanhTien = 0;
                let itemType = null;

                if (typeof _rows[rowIndex] !== 'undefined' && typeof _rows[rowIndex]['name'] !== 'undefined' && typeof _rows[rowIndex]['name']['item_type'] !== 'undefined') {
                    itemType = _rows[rowIndex]['name']['item_type'];
                }

                if (itemType == 'chiphiphatsinh') {
                    if (typeof _rows[rowIndex] !== 'undefined' && typeof _rows[rowIndex]['qtyDoc'] !== 'undefined') {
                        soLuongChungTu = Number(_rows[rowIndex]['qtyDoc']);
                    }

                    if (typeof _rows[rowIndex] !== 'undefined' && typeof _rows[rowIndex]['qtyReal'] !== 'undefined') {
                        soLuongThucNhap = Number(_rows[rowIndex]['qtyReal']);
                    }

                    if (typeof _rows[rowIndex] !== 'undefined' && typeof _rows[rowIndex]['name'] !== 'undefined' && typeof _rows[rowIndex]['name']['chiphiphatsinh_select'] !== 'undefined' && typeof _rows[rowIndex]['name']['chiphiphatsinh_select']['gia'] !== 'undefined') {
                        donGia = Number(_rows[rowIndex]['name']['chiphiphatsinh_select']['gia']);
                    }

                    thanhTien = soLuongThucNhap * donGia;

                    console.log(rowIndex, soLuongChungTu, soLuongThucNhap, donGia, thanhTien);

                    _tongSoLuongChungTu += soLuongChungTu;
                    _tongSoLuongThucNhap += soLuongThucNhap;
                    _tongDonGia += donGia;
                    _tongThanhTien += thanhTien;

                    const newRows = [..._rows];
                    newRows[rowIndex]['total'] = (numeral(thanhTien).format('0,0[.]0'));
                    setRows(newRows);
                } else if (itemType == 'sanpham') {
                    if (typeof _rows[rowIndex] !== 'undefined' && typeof _rows[rowIndex]['qtyDoc'] !== 'undefined') {
                        soLuongChungTu = Number(_rows[rowIndex]['qtyDoc']);
                    }

                    if (typeof _rows[rowIndex] !== 'undefined' && typeof _rows[rowIndex]['qtyReal'] !== 'undefined') {
                        soLuongThucNhap = Number(_rows[rowIndex]['qtyReal']);
                    }

                    if (typeof _rows[rowIndex] !== 'undefined' && typeof _rows[rowIndex]['price'] !== 'undefined') {
                        priceKey = _rows[rowIndex]['price'];
                    }

                    // if (priceKey && typeof _rows[rowIndex] !== 'undefined' && typeof _rows[rowIndex]['name'] !== 'undefined' && typeof _rows[rowIndex]['name']['sanpham_select'] !== 'undefined' && typeof _rows[rowIndex]['name']['sanpham_select'][priceKey] !== 'undefined') {
                    //     donGia = Number(_rows[rowIndex]['name']['sanpham_select'][priceKey]);
                    // }

                    if (typeof _rows[rowIndex] !== 'undefined' && typeof _rows[rowIndex]['gia_custom'] !== 'undefined') {
                        donGia = parseInt(_rows[rowIndex]['gia_custom'].toString().trim().replace(/\D/g, ''));
                    }

                    thanhTien = soLuongThucNhap * donGia;

                    console.log(rowIndex, soLuongChungTu, soLuongThucNhap, donGia, thanhTien);

                    _tongSoLuongChungTu += soLuongChungTu;
                    _tongSoLuongThucNhap += soLuongThucNhap;
                    _tongDonGia += donGia;
                    _tongThanhTien += thanhTien;

                    if (_rows[rowIndex]?.mode == 'sanpham') {
                        _tongSoLuongChungTuSanPham += soLuongChungTu;
                        _tongSoLuongThucNhapSanPham += soLuongThucNhap;
                        _tongDonGiaSanPham += donGia;
                        _tongThanhTienSanPham += thanhTien;
                    }

                    const newRows = [..._rows];
                    newRows[rowIndex]['total'] = (numeral(thanhTien).format('0,0[.]0'));
                    setRows(newRows);
                }
            }
        }

        console.log(_tongSoLuongChungTu, _tongSoLuongThucNhap, _tongDonGia, _tongThanhTien)

        if (loaiPhieu == 'phieu_xuat') {
            setTongSoLuongChungTu(_tongSoLuongChungTuSanPham == 0 ? 'x' : numeral(_tongSoLuongChungTuSanPham).format('0,0[.]0'));
            setTongSoLuongThucNhap(_tongSoLuongThucNhapSanPham == 0 ? 'x' : numeral(_tongSoLuongThucNhapSanPham).format('0,0[.]0'));
            setTongDonGia(_tongDonGiaSanPham == 0 ? 'x' : numeral(_tongDonGiaSanPham).format('0,0[.]0'));
            setTongThanhTien(_tongThanhTienSanPham == 0 ? 'x' : numeral(_tongThanhTienSanPham).format('0,0[.]0'));
        } else if (loaiPhieu == 'phieu_thu') {
            setTongSoLuongChungTu(_tongSoLuongChungTu == 0 ? 'x' : numeral(_tongSoLuongChungTu).format('0,0[.]0'));
            setTongSoLuongThucNhap(_tongSoLuongThucNhap == 0 ? 'x' : numeral(_tongSoLuongThucNhap).format('0,0[.]0'));
            setTongDonGia(_tongDonGia == 0 ? 'x' : numeral(_tongDonGia).format('0,0[.]0'));
            setTongThanhTien(_tongThanhTien == 0 ? 'x' : numeral(_tongThanhTien).format('0,0[.]0'));
        }
        
        setPhieuThuSoTien((_tongThanhTien == 0 ? '0' : numeral(_tongThanhTien).format('0,0[.]0')) + ' VND');
        setPhieuThuSoTienVietBangChu(numberToVietnameseWords(_tongThanhTien) + ' đồng chẵn');
        setTongSoTienVietBangChu(numberToVietnameseWords(_tongThanhTienSanPham) + ' đồng chẵn');
    }

    let stt = 1;

    return (
        <Dialog className='khophieu-view' open={props.open} onClose={props.handleClose}>
            <DialogTitle>
                {props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => { resetState(); recalculate([], false); }}
                    style={{ height: '20px', padding: 0, marginTop: '-5px', width: "150px", minWidth: '20px', marginLeft: '15px', backgroundColor: 'blue', fontWeight: 'normal' }}
                >
                    RESET
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => { setTabSelect('phieu_xuat'); recalculate(rows, true, 'phieu_xuat', false); }}
                    style={{ height: '20px', padding: 0, marginTop: '-5px', width: "150px", minWidth: '20px', marginLeft: '15px', backgroundColor: tabSelect == 'phieu_xuat' ? 'green' : 'orange', fontWeight: 'normal' }}
                >
                    PHIẾU XUẤT KHO
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => { setTabSelect('phieu_thu'); recalculate(rows, true, 'phieu_thu', false); }}
                    style={{ height: '20px', padding: 0, marginTop: '-5px', width: "150px", minWidth: '20px', marginLeft: '15px', backgroundColor: tabSelect == 'phieu_thu' ? 'green' : 'orange', fontWeight: 'normal' }}
                >
                    PHIẾU THU
                </Button>
            </DialogTitle>
            <DialogContent style={{  }}>
                <div className="phieu-container">

                    {tabSelect == 'phieu_xuat' && <>
                        <div className="phieu-header" style={{height: 0}}>
                            <div className="left"></div>
                            <div className="right">
                                <div>Nợ: <input
                                    type="text"
                                    value={no}
                                    onChange={(e) => setNo(e.target.value)}
                                /></div>
                                <div>Có: <input
                                    type="text"
                                    value={co}
                                    onChange={(e) => setCo(e.target.value)}
                                /></div>
                            </div>
                        </div>

                        <h2 className="phieu-title">PHIẾU XUẤT KHO</h2>

                        <div className="phieu-info">
                            <div style={{textAlign: 'center', fontStyle: 'italic'}}>
                                Ngày <input
                                    style={{textAlign: 'center', fontStyle: 'italic'}}
                                    className="small"
                                    type="text"
                                    value={ngay}
                                    onChange={(e) => setNgay(e.target.value)}
                                /> 
                                tháng <input
                                    style={{textAlign: 'center', fontStyle: 'italic'}}
                                    className="small"
                                    type="text"
                                    value={thang}
                                    onChange={(e) => setThang(e.target.value)}
                                /> 
                                năm <input
                                    style={{textAlign: 'center', fontStyle: 'italic'}}
                                    className="small"
                                    type="text"
                                    value={nam}
                                    onChange={(e) => setNam(e.target.value)}
                                />
                            </div>
                            <div style={{textAlign: 'center'}}>Số phiếu: <input
                                style={{textAlign: 'center'}}
                                className="special"
                                // readOnly
                                placeholder="PX000001/25"
                                type="text"
                                value={so}
                                onChange={(e) => setSo(e.target.value)}
                            /></div>
                            <div>
                                - Họ và tên người nhận hàng: <div style={{ display: 'inline-block', margin: '0px', border: 'none', width: '50%', zIndex: '10', marginTop: 0 }} className="full-width-select has-fast-action-btn">
                                    <Button
                                        className="fast-action-btn"
                                        color="primary"
                                        variant="contained"
                                        onClick={() => handleClickOpenNewdanhmuckhachhang()}
                                        style={{ 
                                            backgroundColor: 'orange',
                                        }}
                                    >
                                        +
                                    </Button>
                                    <Select
                                        classNamePrefix="nt-select"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 999999,
                                            }),
                                            control: (provided) => ({
                                                ...provided,
                                                // height: 56,
                                                // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                                border: 'none',
                                            }),
                                            option: (provided) => ({
                                                ...provided,
                                                // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                            }),
                                        }}
                                        options={[additionalOptionKhachhang, ...khachhangList]} // Thêm vào đầu danh sách
                                        getOptionLabel={(item) =>
                                            `${item.ma + (item.ten ? (' - ' + item.ten) : '')}`
                                        }
                                        formatOptionLabel={(item, { context }) => {
                                            const khachhangLine = `${item.ma}${item.ten ? ` - ${item.ten}` : ''}`;

                                            return (
                                                <div>
                                                    <div class='limit-line limit-line-1' style={{ fontWeight: "bold" }}>{khachhangLine}</div>
                                                </div>
                                            );
                                        }}
                                        placeholder={
                                            khachhang_name
                                                ? <span dangerouslySetInnerHTML={{ __html: khachhang_name }} />
                                                : <span style={{fontWeight: 'bold'}}>{defaultSelectKhachHang}</span>
                                        }
                                        components={{
                                            DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                            IndicatorSeparator: null,
                                        }}
                                        value={khachhang_id || null}
                                        onChange={(newValue) => {
                                            const khachhangLine = `<div style="font-weight: bold">${newValue.ma} ${newValue.ten ? ` - ${newValue.ten}` : ''}</div>`;
                                        
                                            const html = `
                                                <div>
                                                    ${khachhangLine}
                                                </div>
                                            `;
                                        
                                            setKhachhangId(newValue.id);
                                            setKhachhangName(html);
                                            setKhachhangSelect(newValue);
                                            setHoVaTenNguoiNhan(newValue.ten);
                                            setDiaChiNguoiNhan(newValue.dia_chi);
                                            setSoDienThoaiNguoiNhan(newValue.sdt)
                                        }}
                                        isSearchable
                                    />
                                </div><input
                                    readOnly
                                    style={{width: '250px', display: 'none'}}
                                    type="text"
                                    value={ho_va_ten_nguoi_nhan}
                                    onChange={(e) => setHoVaTenNguoiNhan(e.target.value)}
                                /> Số điện thoại: <input
                                    readOnly
                                    style={{width: '100px', textAlign: 'left'}}
                                    className="small"
                                    type="text"
                                    value={so_dien_thoai_nguoi_nhan}
                                    onChange={(e) => setSoDienThoaiNguoiNhan(e.target.value)}
                                />
                            </div>
                            <div style={{marginTop: 6}}>- Địa chỉ: <input
                                readOnly
                                style={{width: '250px'}}
                                type="text"
                                value={dia_chi_nguoi_nhan}
                                onChange={(e) => setDiaChiNguoiNhan(e.target.value)}
                            /></div>
                            <div style={{marginTop: 6}}>- Lý do xuất kho: <input
                                style={{width: '250px'}}
                                type="text"
                                value={ly_do_xuat_kho}
                                onChange={(e) => setLyDoXuatKho(e.target.value)}
                            /></div>
                            <div>
                                - Xuất tại kho: 
                                
                                <div style={{ display: 'inline-block', margin: '0px', border: 'none', width: '50%', zIndex: '10', marginTop: 0 }} className="full-width-select has-fast-action-btn">
                                    <Button
                                        className="fast-action-btn"
                                        color="primary"
                                        variant="contained"
                                        onClick={() => handleClickOpenNewdanhmuckhohang()}
                                        style={{ 
                                            backgroundColor: 'orange',
                                        }}
                                    >
                                        +
                                    </Button>
                                    <Select
                                        classNamePrefix="nt-select"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 999999,
                                            }),
                                            control: (provided) => ({
                                                ...provided,
                                                // height: 56,
                                                // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                                border: 'none',
                                            }),
                                            option: (provided) => ({
                                                ...provided,
                                                // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                            }),
                                        }}
                                        options={[additionalOptionKhohang, ...khohangList]} // Thêm vào đầu danh sách
                                        getOptionLabel={(item) =>
                                            `${item.ma + (item.ten ? (' - ' + item.ten) : '')}`
                                        }
                                        formatOptionLabel={(item, { context }) => {
                                            const khohangLine = `${item.ma}${item.ten ? ` - ${item.ten}` : ''}`;

                                            return (
                                                <div>
                                                    <div class='limit-line limit-line-1' style={{ fontWeight: "bold" }}>{khohangLine}</div>
                                                </div>
                                            );
                                        }}
                                        placeholder={
                                            khohang_name
                                                ? <span dangerouslySetInnerHTML={{ __html: khohang_name }} />
                                                : <span style={{fontWeight: 'bold'}}>{defaultSelectKhoHang}</span>
                                        }
                                        components={{
                                            DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                            IndicatorSeparator: null,
                                        }}
                                        value={khohang_id || null}
                                        onChange={(newValue) => {
                                            const khohangLine = `<div style="font-weight: bold">${newValue.ma} ${newValue.ten ? ` - ${newValue.ten}` : ''}</div>`;
                                        
                                            const html = `
                                                <div>
                                                    ${khohangLine}
                                                </div>
                                            `;
                                        
                                            setKhohangId(newValue.id);
                                            setKhohangName(html);
                                            setKhohangSelect(newValue);
                                            setDiaChi(newValue.dia_chi);
                                        }}
                                        isSearchable
                                    />
                                </div>

                                Địa điểm: <input
                                    readOnly
                                    type="text"
                                    value={dia_chi}
                                    onChange={(e) => setDiaChi(e.target.value)}
                                />
                            </div>
                        </div>
                    </>}

                    {tabSelect == 'phieu_thu' && <>
                        <div className="phieu-header" style={{height: 0}}>
                            <div className="left"></div>
                            <div className="right">
                                <div>Quyển số: <input
                                    type="text"
                                    value={phieu_thu_quyen_so}
                                    onChange={(e) => setPhieuThuQuyenSo(e.target.value)}
                                /></div>
                                <div>Số: <input
                                    className="special"
                                    placeholder="PT000001/25"
                                    type="text"
                                    value={phieu_thu_so}
                                    onChange={(e) => setPhieuThuSo(e.target.value)}
                                /></div>
                                <div>Nợ: <input
                                    type="text"
                                    value={phieu_thu_no}
                                    onChange={(e) => setPhieuThuNo(e.target.value)}
                                /></div>
                                <div>Có: <input
                                    type="text"
                                    value={phieu_thu_co}
                                    onChange={(e) => setPhieuThuCo(e.target.value)}
                                /></div>
                            </div>
                        </div>

                        <h2 className="phieu-title">PHIẾU THU</h2>

                        <div className="phieu-info">
                            <div style={{textAlign: 'center', fontStyle: 'italic', marginBottom: '15px'}}>
                                Ngày <input
                                    style={{textAlign: 'center', fontStyle: 'italic'}}
                                    className="small"
                                    type="text"
                                    value={ngay}
                                    onChange={(e) => setNgay(e.target.value)}
                                /> 
                                tháng <input
                                    style={{textAlign: 'center', fontStyle: 'italic'}}
                                    className="small"
                                    type="text"
                                    value={thang}
                                    onChange={(e) => setThang(e.target.value)}
                                /> 
                                năm <input
                                    style={{textAlign: 'center', fontStyle: 'italic'}}
                                    className="small"
                                    type="text"
                                    value={nam}
                                    onChange={(e) => setNam(e.target.value)}
                                />
                            </div>
                            <div>
                                - Họ và tên người nộp tiền: <div style={{ display: 'inline-block', margin: '0px', border: 'none', width: '50%', zIndex: '10', marginTop: 0 }} className="full-width-select has-fast-action-btn">
                                    <Button
                                        className="fast-action-btn"
                                        color="primary"
                                        variant="contained"
                                        onClick={() => handleClickOpenNewdanhmuckhachhang()}
                                        style={{ 
                                            backgroundColor: 'orange',
                                        }}
                                    >
                                        +
                                    </Button>
                                    <Select
                                        classNamePrefix="nt-select"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 999999,
                                            }),
                                            control: (provided) => ({
                                                ...provided,
                                                // height: 56,
                                                // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                                border: 'none',
                                            }),
                                            option: (provided) => ({
                                                ...provided,
                                                // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                            }),
                                        }}
                                        options={[additionalOptionKhachhang, ...khachhangList]} // Thêm vào đầu danh sách
                                        getOptionLabel={(item) =>
                                            `${item.ma + (item.ten ? (' - ' + item.ten) : '')}`
                                        }
                                        formatOptionLabel={(item, { context }) => {
                                            const khachhangLine = `${item.ma}${item.ten ? ` - ${item.ten}` : ''}`;

                                            return (
                                                <div>
                                                    <div class='limit-line limit-line-1' style={{ fontWeight: "bold" }}>{khachhangLine}</div>
                                                </div>
                                            );
                                        }}
                                        placeholder={
                                            khachhang_name
                                                ? <span dangerouslySetInnerHTML={{ __html: khachhang_name }} />
                                                : <span style={{fontWeight: 'bold'}}>{defaultSelectKhachHang}</span>
                                        }
                                        components={{
                                            DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                            IndicatorSeparator: null,
                                        }}
                                        value={khachhang_id || null}
                                        onChange={(newValue) => {
                                            const khachhangLine = `<div style="font-weight: bold">${newValue.ma} ${newValue.ten ? ` - ${newValue.ten}` : ''}</div>`;
                                        
                                            const html = `
                                                <div>
                                                    ${khachhangLine}
                                                </div>
                                            `;
                                        
                                            setKhachhangId(newValue.id);
                                            setKhachhangName(html);
                                            setKhachhangSelect(newValue);
                                            setHoVaTenNguoiNhan(newValue.ten);
                                            setDiaChiNguoiNhan(newValue.dia_chi);
                                            setSoDienThoaiNguoiNhan(newValue.sdt)
                                        }}
                                        isSearchable
                                    />
                                </div><input
                                    readOnly
                                    style={{width: '250px', display: 'none'}}
                                    type="text"
                                    value={ho_va_ten_nguoi_nhan}
                                    onChange={(e) => setHoVaTenNguoiNhan(e.target.value)}
                                /> Số điện thoại: <input
                                    readOnly
                                    style={{width: '100px', textAlign: 'left'}}
                                    className="small"
                                    type="text"
                                    value={so_dien_thoai_nguoi_nhan}
                                    onChange={(e) => setSoDienThoaiNguoiNhan(e.target.value)}
                                />
                            </div>
                            <div>- Địa chỉ: <input
                                readOnly
                                style={{width: '850px', maxWidth: '100%'}}
                                type="text"
                                value={dia_chi_nguoi_nhan}
                                onChange={(e) => setDiaChiNguoiNhan(e.target.value)}
                            /></div>
                            <div>- Lý do nộp: <input
                                style={{width: '850px', maxWidth: '100%'}}
                                type="text"
                                value={phieu_thu_noi_dung_thu}
                                onChange={(e) => setPhieuThuNoiDungThu(e.target.value)}
                            /></div>
                            <div>- Số tiền: <input
                                readOnly
                                style={{width: '850px', maxWidth: '100%'}}
                                type="text"
                                value={phieu_thu_so_tien}
                                onChange={(e) => setPhieuThuSoTien(e.target.value)}
                            /></div>
                            <div>&nbsp;&nbsp;(Viết bằng chữ): <input
                                readOnly
                                style={{width: '850px', maxWidth: '100%'}}
                                type="text"
                                value={phieu_thu_so_tien_viet_bang_chu}
                                onChange={(e) => setPhieuThuSoTienVietBangChu(e.target.value)}
                            /></div>
                            <div>- Kèm theo: <input
                                style={{width: '850px', maxWidth: '100%'}}
                                type="text"
                                value={phieu_thu_kem_theo}
                                onChange={(e) => setPhieuThuKemTheo(e.target.value)}
                            /></div>
                            <div>&nbsp;&nbsp;Chứng từ gốc: <input
                                style={{width: '850px', maxWidth: '100%'}}
                                type="text"
                                value={phieu_thu_chung_tu_goc}
                                onChange={(e) => setPhieuThuChungTuGoc(e.target.value)}
                            /></div>
                        </div>
                    </>}

                    {/* Bảng sản phẩm */}
                    <div className="table-wrapper">
                        <table className="phieu-table">
                            {tabSelect == 'phieu_xuat' && <thead>
                                <tr>
                                    <th rowSpan="2">STT</th>
                                    <th rowSpan="2">Tên, nhãn hiệu, quy cách, phẩm chất vật tư, dụng cụ sản phẩm, hàng hóa</th>
                                    <th rowSpan="2">Mã số</th>
                                    <th rowSpan="2">Đơn vị tính</th>
                                    <th colSpan="1" rowSpan="2" width="100">Số lượng</th>
                                    <th rowSpan="2" width="250">Đơn giá<br></br>(VND)</th>
                                    <th rowSpan="2">Thành tiền<br></br>(VND)</th>
                                    <th rowSpan="2">Ghi chú</th>
                                    <th rowSpan="3">Xóa</th>
                                </tr>
                                <tr></tr>
                                <tr>
                                    <th>A</th>
                                    <th>B</th>
                                    <th>C</th>
                                    <th>D</th>
                                    <th>1</th>
                                    <th>2</th>
                                    <th>3</th>
                                    <th>4</th>
                                </tr>
                            </thead>}

                            {tabSelect == 'phieu_thu' && <thead>
                                <tr>
                                    <th rowSpan="2">STT</th>
                                    <th rowSpan="2">Nội dung thu tiền</th>
                                    <th rowSpan="2">Mã số</th>
                                    <th rowSpan="2">Đơn vị tính</th>
                                    <th rowSpan="2" width="100">Số lượng</th>
                                    <th rowSpan="2" width="250">Đơn giá<br></br>(VND)</th>
                                    <th rowSpan="2">Thành tiền<br></br>(VND)</th>
                                    <th rowSpan="2">Ghi chú</th>
                                    <th rowSpan="3">Xóa</th>
                                </tr>
                                <tr></tr>
                                <tr>
                                    <th>A</th>
                                    <th>B</th>
                                    <th>C</th>
                                    <th>D</th>
                                    <th>1</th>
                                    <th>2</th>
                                    <th>3</th>
                                    <th>4</th>
                                </tr>
                            </thead>}

                            <tbody>
                                {rows.map((row, rowIndex) => {
                                    const fields = ["name", "code", "unit", "qtyDoc", "qtyReal", "price", "total", "ghi_chu"];

                                    if (rows[rowIndex]?.mode == 'chiphiphatsinh' && tabSelect === 'phieu_xuat') {
                                        return null;
                                    }

                                    return (
                                        <tr key={row.id}>
                                            <td>{stt++}</td>
                                            {fields.map((field, fieldIndex) => {
                                                if (field === 'qtyDoc') {
                                                    return null;
                                                }
                                                
                                                return (
                                                    <td key={field}>
                                                        {field !== 'name' && field !== 'price' && <input
                                                            type="text"
                                                            value={row[field]}
                                                            // placeholder={
                                                            //     field === 'unit'
                                                            //         ? 'Chiếc'
                                                            //         : field === 'qtyDoc'
                                                            //         ? '1'
                                                            //         : field === 'qtyReal'
                                                            //         ? '1'
                                                            //         : ''
                                                            // }
                                                            placeholder="..."
                                                            readOnly={field === 'code' || field === 'total' || field === 'qtyDoc' && rows[rowIndex]?.mode === 'chiphiphatsinh'}
                                                            onChange={(e) => {
                                                                const newRows = [...rows];
                                                                newRows[rowIndex][field] = e.target.value;
                                                                setRows(newRows);
                                                                recalculate();
                                                            }}
                                                            ref={(el) => (inputsRef.current[`${rowIndex}-${field}`] = el)}
                                                            onKeyDown={(e) => handleKeyDown(e, rowIndex, fieldIndex)}
                                                        />}

                                                        {field === 'price' && !rows[rowIndex]?.name?.sanpham_id && !rows[rowIndex]?.name?.chiphiphatsinh_id && (
                                                            <b style={{color: 'blue'}}>...</b>
                                                        )}

                                                        {field === 'price' && rows[rowIndex]?.name?.item_type == 'chiphiphatsinh' && (
                                                            <b style={{color: 'blue'}}>{numeral(rows[rowIndex].name.chiphiphatsinh_select.gia).format('0,0[.]0')}</b>
                                                        )}
                                                        
                                                        {field === 'price' && rows[rowIndex]?.name?.item_type == 'sanpham' && (
                                                            <input
                                                                type="text"
                                                                value={row['gia_custom']}
                                                                placeholder="..."
                                                                onChange={(e) => {
                                                                    const newRows = [...rows];
                                                                    newRows[rowIndex]['gia_custom'] = e.target.value;
                                                                    setRows(newRows);
                                                                    recalculate();
                                                                }}
                                                                ref={(el) => (inputsRef.current[`${rowIndex}-${field}`] = el)}
                                                                onKeyDown={(e) => handleKeyDown(e, rowIndex, fieldIndex)}
                                                            />
                                                        )}

                                                        {field === 'name' && <>
                                                            {tabSelect == 'phieu_thu' && <Select1
                                                                className=""
                                                                style={{
                                                                    // height: 56,
                                                                    marginTop: 0,
                                                                    marginBottom: 0,
                                                                    width: "100%",
                                                                    marginLeft: 0,
                                                                }}
                                                                value={rows[rowIndex]?.mode}
                                                                onChange={(e) => {
                                                                    const newRows = [...rows];
                                                                    newRows[rowIndex]['mode'] = e.target.value;
                                                                    console.log(e.target.value);
                                                                    setRows(newRows);
                                                                    recalculate();
                                                                }}
                                                                variant="outlined"
                                                                >
                                                                <MenuItem value="sanpham">- Loại khoản thu: Sản phẩm</MenuItem>
                                                                <MenuItem value="chiphiphatsinh">- Loại khoản thu: Chi phí phát sinh</MenuItem>
                                                            </Select1>}
                                                            {rows[rowIndex]?.mode === "chiphiphatsinh" && 
                                                                <div style={{ width: '100%', zIndex: '10', marginTop: 15 }} className="full-width-select has-fast-action-btn">
                                                                    <Button
                                                                        className="fast-action-btn"
                                                                        color="primary"
                                                                        variant="contained"
                                                                        onClick={() => handleClickOpenNewdanhmucchiphiphatsinh()}
                                                                        style={{ 
                                                                            backgroundColor: 'orange',
                                                                        }}
                                                                    >
                                                                        +
                                                                    </Button>
                                                                    <Select
                                                                        classNamePrefix="nt-select"
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            menuPortal: base => ({
                                                                                ...base,
                                                                                zIndex: 999999,
                                                                            }),
                                                                            control: (provided) => ({
                                                                                ...provided,
                                                                                // height: 56,
                                                                                // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                                                                border: 'none',
                                                                            }),
                                                                            option: (provided) => ({
                                                                                ...provided,
                                                                                // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                                                            }),
                                                                        }}
                                                                        options={[additionalOptionChiphiphatsinh, ...chiphiphatsinhList]} // Thêm vào đầu danh sách
                                                                        getOptionLabel={(item) =>
                                                                            `${item.ma + (item.ten ? (' - ' + item.ten) : '')}`
                                                                        }
                                                                        formatOptionLabel={(item, { context }) => {
                                                                            const chiphiphatsinhLine = `${item.ma}${item.ten ? ` - ${item.ten}` : ''}`;

                                                                            return (
                                                                                <div>
                                                                                    <div class='limit-line limit-line-1' style={{ fontWeight: "bold" }}>{chiphiphatsinhLine}</div>
                                                                                </div>
                                                                            );
                                                                        }}
                                                                        placeholder={
                                                                            typeof rows[rowIndex][field] !== 'undefined' && typeof rows[rowIndex][field]['chiphiphatsinh_name'] !== 'undefined' && rows[rowIndex][field]['chiphiphatsinh_name']
                                                                                ? <span dangerouslySetInnerHTML={{ __html: rows[rowIndex][field]['chiphiphatsinh_name'] }} />
                                                                                : <span style={{fontWeight: 'bold'}}>{defaultSelectChiphiphatsinh}</span>
                                                                        }
                                                                        components={{
                                                                            DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                                                            IndicatorSeparator: null,
                                                                        }}
                                                                        value={typeof rows[rowIndex][field] !== 'undefined' && typeof rows[rowIndex][field]['chiphiphatsinh_id'] !== 'undefined' ? rows[rowIndex][field]['chiphiphatsinh_id'] : '-99'}
                                                                        onChange={(newValue) => {
                                                                            console.log(rows);

                                                                            const exists = rows.some(row => 
                                                                                (row?.chiphiphatsinh_ma ?? row?.name?.chiphiphatsinh_ma) === newValue.ma
                                                                            );

                                                                            if (exists) {
                                                                                alert(`Chi phí phát sinh có mã "${newValue.ma}" đã tồn tại!`);
                                                                                return;
                                                                            }

                                                                            const chiphiphatsinhLine = `<div style="font-weight: bold">${newValue.ten ? `${newValue.ten}` : ''}</div>`;
                                                                        
                                                                            const html = `
                                                                                <div>
                                                                                    ${chiphiphatsinhLine}
                                                                                </div>
                                                                            `;

                                                                            const newRows = [...rows];
                                                                            newRows[rowIndex][field] = {
                                                                                chiphiphatsinh_id: newValue.id,
                                                                                chiphiphatsinh_ma: newValue.ma,
                                                                                chiphiphatsinh_name: html,
                                                                                chiphiphatsinh_select: newValue,
                                                                                item_type: 'chiphiphatsinh',
                                                                            };
                                                                            newRows[rowIndex]['code'] = newValue.ma;
                                                                            newRows[rowIndex]['mode'] = 'chiphiphatsinh';
                                                                            newRows[rowIndex]['qtyDoc'] = '0';
                                                                            setRows(newRows);
                                                                            recalculate();
                                                                        }}
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                            }

                                                            {rows[rowIndex]?.mode === "sanpham" && <>
                                                                <div style={{ width: '100%', zIndex: '10', marginTop: 15 }} className="full-width-select has-fast-action-btn">
                                                                    <Button
                                                                        className="fast-action-btn"
                                                                        color="primary"
                                                                        variant="contained"
                                                                        onClick={() => handleClickOpenNewdanhmucsanpham()}
                                                                        style={{ 
                                                                            backgroundColor: 'orange',
                                                                        }}
                                                                    >
                                                                        +
                                                                    </Button>
                                                                    <Select
                                                                        classNamePrefix="nt-select"
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            menuPortal: base => ({
                                                                                ...base,
                                                                                zIndex: 999999,
                                                                            }),
                                                                            control: (provided) => ({
                                                                                ...provided,
                                                                                // height: 56,
                                                                                // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                                                                border: 'none',
                                                                            }),
                                                                            option: (provided) => ({
                                                                                ...provided,
                                                                                // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                                                            }),
                                                                        }}
                                                                        options={[additionalOptionSanpham, ...sanphamList]} // Thêm vào đầu danh sách
                                                                        getOptionLabel={(item) =>
                                                                            `${item.ma + (item.ten ? (' - ' + item.ten) : '') + (typeof item.newdanhmucnhacungcap_ref !== 'undefined' ? (' (' + item.newdanhmucnhacungcap_ref.ma + ' - ' + item.newdanhmucnhacungcap_ref.ten + ')') : '')}`
                                                                        }
                                                                        formatOptionLabel={(item, { context }) => {
                                                                            const productLine = `${item.ma}${item.ten ? ` - ${item.ten}` : ''}`;
                                                                            const ncc = item.newdanhmucnhacungcap_ref
                                                                                ? `${item.newdanhmucnhacungcap_ref.ma} - ${item.newdanhmucnhacungcap_ref.ten}`
                                                                                : null;

                                                                            return (
                                                                                <div>
                                                                                    <div class='limit-line limit-line-1' style={{ fontWeight: "bold" }}>{productLine}</div>
                                                                                    {ncc && <div class='limit-line limit-line-1'>({ncc})</div>}
                                                                                </div>
                                                                            );
                                                                        }}
                                                                        // placeholder={(sanpham_id !== '-99' ? sanpham_id : defaultSelectSanPham) || defaultSelectSanPham}
                                                                        placeholder={
                                                                            typeof rows[rowIndex][field] !== 'undefined' && typeof rows[rowIndex][field]['sanpham_name'] !== 'undefined' && rows[rowIndex][field]['sanpham_name']
                                                                                ? <span dangerouslySetInnerHTML={{ __html: rows[rowIndex][field]['sanpham_name'] }} />
                                                                                : <span style={{fontWeight: 'bold'}}>{defaultSelectSanPham}</span>
                                                                        }
                                                                        components={{
                                                                            DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                                                            IndicatorSeparator: null,
                                                                        }}
                                                                        value={typeof rows[rowIndex][field] !== 'undefined' && typeof rows[rowIndex][field]['sanpham_id'] !== 'undefined' ? rows[rowIndex][field]['sanpham_id'] : '-99'}
                                                                        // onChange={(newValue) => { setSanphamId(newValue.id); setSanphamName(newValue.ma + ' - ' + newValue.ten + (typeof newValue.newdanhmucnhacungcap_ref !== 'undefined' ? (' (' + newValue.newdanhmucnhacungcap_ref.ma + ' - ' + newValue.newdanhmucnhacungcap_ref.ten + ')') : '')); setSanphamSelect(newValue); }}
                                                                        onChange={(newValue) => {
                                                                            console.log(rows);

                                                                            // const exists = rows.some(row => 
                                                                            //     (row?.sanpham_ma ?? row?.name?.sanpham_ma) === newValue.ma
                                                                            // );

                                                                            // if (exists) {
                                                                            //     alert(`Sản phẩm có mã "${newValue.ma}" đã tồn tại!`);
                                                                            //     return;
                                                                            // }

                                                                            const productLine = `<div style="font-weight: bold">${newValue.ten ? `${newValue.ten}` : ''}</div>`;
                                                                            const ncc = newValue.newdanhmucnhacungcap_ref
                                                                                ? `<div>(${newValue.newdanhmucnhacungcap_ref.ma} - ${newValue.newdanhmucnhacungcap_ref.ten})<div>`
                                                                                : '';
                                                                        
                                                                            const html = `
                                                                                <div>
                                                                                    ${productLine}
                                                                                    ${ncc}
                                                                                </div>
                                                                            `;
                                                                        
                                                                            // setSanphamId(newValue.id);
                                                                            // setSanphamName(html);
                                                                            // setSanphamSelect(newValue);

                                                                            const newRows = [...rows];
                                                                            newRows[rowIndex][field] = {
                                                                                sanpham_id: newValue.id,
                                                                                sanpham_ma: newValue.ma,
                                                                                sanpham_name: html,
                                                                                sanpham_select: newValue,
                                                                                item_type: 'sanpham',
                                                                            };
                                                                            newRows[rowIndex]['code'] = newValue.ma;
                                                                            newRows[rowIndex]['mode'] = 'sanpham';
                                                                            setRows(newRows);
                                                                            recalculate();
                                                                        }}
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                                <div style={{ width: '100%', zIndex: '10', marginTop: 15 }} className="full-width-select has-fast-action-btn dangkiem-select">
                                                                    <Select
                                                                        classNamePrefix="nt-select"
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            menuPortal: base => ({
                                                                                ...base,
                                                                                zIndex: 999999,
                                                                            }),
                                                                            control: (provided) => ({
                                                                                ...provided,
                                                                                // height: 56,
                                                                                // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                                                                border: 'none',
                                                                            }),
                                                                            option: (provided) => ({
                                                                                ...provided,
                                                                                // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                                                            }),
                                                                        }}
                                                                        options={[additionalOptionDangkiem, ...rows[rowIndex]?.name?.sanpham_select?.newdanhmucdangkiems || []]}
                                                                        getOptionLabel={(item) =>
                                                                            `${item.id == '-99' ? item.ma : ''}${item.so_khung ? `SK: ${item.so_khung}` : ''}${item.so_may ? ` - SM: ${item.so_may}` : ''}`
                                                                        }
                                                                        formatOptionLabel={(item, { context }) => {
                                                                            const soKhungLine = `${item.so_khung ? `SK: ${item.so_khung}` : ''}`;
                                                                            const soMayLine = `${item.so_may ? `SM: ${item.so_may}` : ''}`;

                                                                            return (
                                                                                <div>
                                                                                    <div class='limit-line limit-line-1' style={{ fontStyle: "italic" }}>{item.id == '-99' ? item.ma : ''}</div>
                                                                                    <div class='limit-line limit-line-1' style={{ fontStyle: "italic" }}>{soKhungLine}</div>
                                                                                    <div class='limit-line limit-line-1' style={{ fontStyle: "italic" }}>{soMayLine}</div>
                                                                                </div>
                                                                            );
                                                                        }}
                                                                        placeholder={
                                                                            typeof rows[rowIndex]['dangkiem'] !== 'undefined' && typeof rows[rowIndex]['dangkiem']['dangkiem_name'] !== 'undefined' && rows[rowIndex]['dangkiem']['dangkiem_name']
                                                                                ? <span dangerouslySetInnerHTML={{ __html: rows[rowIndex]['dangkiem']['dangkiem_name'] }} />
                                                                                : <span style={{fontStyle: 'italic'}}>{defaultSelectDangkiem}</span>
                                                                        }
                                                                        components={{
                                                                            DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                                                            IndicatorSeparator: null,
                                                                        }}
                                                                        value={typeof rows[rowIndex]['dangkiem'] !== 'undefined' && typeof rows[rowIndex]['dangkiem']['dangkiem_id'] !== 'undefined' ? rows[rowIndex]['dangkiem']['dangkiem_id'] : '-99'}
                                                                        onChange={(newValue) => {
                                                                            console.log(rows);

                                                                            const soKhungLine = `<div style="font-style: italic">${newValue.so_khung ? `SK: ${newValue.so_khung}` : ''}</div>`;
                                                                            const soMayLine = `<div style="font-style: italic">${newValue.so_may ? `SM: ${newValue.so_may}` : ''}</div>`;
                                                                        
                                                                            const html = `
                                                                                <div>
                                                                                    ${soKhungLine}
                                                                                    ${soMayLine}
                                                                                </div>
                                                                            `;

                                                                            const newRows = [...rows];
                                                                            newRows[rowIndex]['dangkiem'] = {
                                                                                dangkiem_id: newValue.id,
                                                                                dangkiem_so_khung: newValue.so_khung,
                                                                                dangkiem_so_may: newValue.so_may,
                                                                                dangkiem_name: html,
                                                                                dangkiem_select: newValue,
                                                                            };
                                                                            setRows(newRows);
                                                                            recalculate();
                                                                        }}
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                            </>}
                                                        </>}
                                                    </td>
                                                );
                                            })}
                                            <td>
                                                <button
                                                    onClick={() => {
                                                        removeRow(row.id);
                                                    }}
                                                    className="remove-btn"
                                                >
                                                    X
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                                <tr style={{fontWeight: 'bold'}}>
                                    {tabSelect == 'phieu_xuat' && <>
                                        <td colSpan="4">Cộng</td>
                                        {/* <td>{tongSoLuongChungTu}</td> */}
                                        <td>{tongSoLuongThucNhap}</td>
                                        <td>{tongDonGia}</td>
                                        <td>{tongThanhTien}</td>
                                        <td>x</td>
                                        <td></td>
                                    </>}
                                    {tabSelect == 'phieu_thu' && <>
                                        <td colSpan="4">Cộng</td>
                                        <td>{tongSoLuongThucNhap}</td>
                                        <td>{tongDonGia}</td>
                                        <td>{tongThanhTien}</td>
                                        <td>x</td>
                                        <td></td>
                                    </>}
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="btn-wrapper">
                        <button onClick={addRow} className="add-btn">+ Thêm dòng</button>
                    </div>

                    {tabSelect == 'phieu_xuat' && <>
                        <div className="phieu-info" style={{marginTop: '15px'}}>
                            <div>- Tổng số tiền (viết bằng chữ): <input
                                style={{width: '850px', maxWidth: '100%'}}
                                readOnly
                                type="text"
                                value={tong_so_tien_viet_bang_chu}
                                onChange={(e) => setTongSoTienVietBangChu(e.target.value)}
                            /></div>
                            <div>- Số chứng từ gốc kèm theo: <input
                                style={{width: '850px', maxWidth: '100%'}}
                                type="text"
                                value={so_chung_tu_goc_kem_theo}
                                onChange={(e) => setSoChungTuGocKemTheo(e.target.value)}
                            /></div>
                        </div>
                    </>}

                    {tabSelect == 'phieu_thu' && <>
                        <div className="phieu-info" style={{marginTop: '15px'}}>
                            <div>Đã nhận đủ số tiền (viết bằng chữ): <input
                                style={{width: '850px', maxWidth: '100%'}}
                                type="text"
                                value={phieu_thu_da_nhan_du_so_tien_viet_bang_chu}
                                onChange={(e) => setPhieuThuDaNhanDuSoTienVietBangChu(e.target.value)}
                            /></div>
                            <div>+ Tỷ giá ngoại tệ (vàng bạc, đá quý): <input
                                style={{width: '850px', maxWidth: '100%'}}
                                type="text"
                                value={phieu_thu_ty_gia_ngoai_te}
                                onChange={(e) => setPhieuThuTyGiaNgoaiTe(e.target.value)}
                            /></div>
                            <div>+ Số tiền quy đổi: <input
                                style={{width: '850px', maxWidth: '100%'}}
                                type="text"
                                value={phieu_thu_so_tien_quy_doi}
                                onChange={(e) => setPhieuThuSoTienQuyDoi(e.target.value)}
                            /></div>
                            <div>(Liên gửi ra ngoài phải đóng dấu)</div>
                        </div>
                    </>}
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose}>Huỷ</Button>
                <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
            </DialogActions>
            <CreateEditDialogNewdanhmuckhachhang open={openNewdanhmuckhachhang} handleClose={handleCloseNewdanhmuckhachhang} type={"CREATE"} creatingFromAway={true} />
            <CreateEditDialogNewdanhmuckhohang open={openNewdanhmuckhohang} handleClose={handleCloseNewdanhmuckhohang} type={"CREATE"} creatingFromAway={true} />
            <CreateEditDialogNewdanhmucsanpham open={openNewdanhmucsanpham} handleClose={handleCloseNewdanhmucsanpham} type={"CREATE"} creatingFromAway={true} />
            <CreateEditDialogNewdanhmucchiphiphatsinh open={openNewdanhmucchiphiphatsinh} handleClose={handleCloseNewdanhmucchiphiphatsinh} type={"CREATE"} creatingFromAway={true} />
        </Dialog >
    );
}

export default CreateEditDialog;